export const mixinMailingBoss = {
    data() {
      return {
        hostMap: {
          '.sitebuilder-publication.kub.app.builderall.io': {
            mboss: 'https://mb5app.kub.app.builderall.io'
          },

          '.sitebuilder-publication.kub.app.builderall.info': {
            mboss: 'https://mb5app.kub.app.builderall.info'     
          },
          
          'default': {
            mboss: 'https://app.mailingboss.com'            
          }
        }
      };
    },
    methods: {
      getMailingBossUrl(host = null) {        
        
        if (host !== null) {
          const foundKey   = Object.keys(this.hostMap).find(key => host.includes(key));
          const hostConfig = this.hostMap[foundKey] || this.hostMap['default'];
          
          return hostConfig.mboss;
        }

        return 'https://app.mailingboss.com';

      }
    }
  };
  